import React from 'react';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function PromptEngineerDraft({ draftText, onBack, onContinue, onSkipOptimization, onChangeDraft }) {
    const helperLines = [
        'The AI Instruction Architect has engineered your instructions, but no one knows your audience better than you do.',
        'Please review the draft below before moving on to the final optimization step.',
        'Think of this as your rough draft. Grab your red pen if needed and make any edits before the AI Instruction Architect does the final once-over.'
    ];

    return (
        <Card elevation={2}>
            <CardContent>
                <Stack spacing={2}>
                    <Typography variant="h6" align="center">Review Your AI Instruction Architect Engineered Draft</Typography>
                    <Stack spacing={1.25} alignItems="center">
                        {helperLines.map((line) => (
                            <Chip
                                key={line}
                                label={line}
                                variant="outlined"
                                color="primary"
                                sx={{
                                    bgcolor: 'common.white',
                                    maxWidth: '100%',
                                    '& .MuiChip-label': {
                                        fontSize: '0.95rem',
                                        py: 1,
                                        px: 1.5,
                                        whiteSpace: 'normal',
                                        textAlign: 'center',
                                        lineHeight: 1.35
                                    }
                                }}
                            />
                        ))}
                    </Stack>
                    <TextField
                        label="Engineered Instruction Draft"
                        value={draftText}
                        onChange={(event) => onChangeDraft(event.target.value)}
                        InputLabelProps={{
                            sx: {
                                fontSize: '1rem',
                                fontWeight: 600,
                                '&.Mui-focused': {
                                    color: 'primary.main'
                                }
                            }
                        }}
                        minRows={20}
                        multiline
                        fullWidth
                    />
                    <Stack direction="row" spacing={2}>
                        <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={onBack}>
                            Back
                        </Button>
                        <Button variant="contained" onClick={onContinue}>
                            ✨ Optimize Instructions
                        </Button>
                        <Button variant="outlined" onClick={onSkipOptimization}>
                            I'm Happy With My Draft
                        </Button>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );
}
